<div class="content">
  <div class="main">
    <div class="container-fluid full-width">
      <div class="top-cont">
        <div class="business-services__container_pay">
          <div class="payment-services__inner-div_bus cus-bnd">
            <nav aria-label="breadcrumb" class="bread_cus">
              <ol class="breadcrumb">

                <li class="breadcrumb-item"><a href="/business-services/" style="color: #5F5753;">Business Services</a>
                </li>
                <li class="breadcrumb-item">
                  <p id="sub-head" style="color: #5F5753;  text-decoration:none;">Enhanced C.O.D.
                    Services</p>
                </li>


              </ol>
            </nav>
            <span>
              <h3 class="payment-services__inner-div--heading_bus bnd-0">Enhanced C.O.D.<br> Services
              </h3>
              <hr class="payment-services__hr_bus">
            </span>
            <div class="payment-services__inner-div--content bus_wor0">Expedite payments, protect your
              cash flow and manage customer check deposits with enhanced C.O.D. payment options.</div>
            <div class="hero-panel-button bus_btn">
              <a href="/contact-us" class="get-secret-btn">Contact Us<img class="arrow-head-left"
                  src="../../../../assets/redesignImages/button-menu.png"></a>
            </div>


          </div>
          <img class="business-services__image_bus cus" src="../../../../assets/redesignImages/Pen_in_hand.png">

        </div>
        <img id="bottom-img" class="media-margin-value" src="../../../../assets/redesignImages/Vector.png">

      </div>

      <div class="container input-form">
        <p class="featured-resources__inner-container mrg">Types of C.O.D. Services</p>
        <hr class="featured-resources__hr tor">


      </div>
      <div class="row container-fluid cont-bg0">
        <div class="col-md-4 max-1200 ic-grp ">
          <div class="text-center  img-tag">

          </div>

          <div>

            <p class="tit-0 maj">C.O.D. Secure<sup>®</sup></p>
            <p class="tit-0 sml">Receive C.O.D. payments in approximately 2-3 days from the delivery
              date and get guaranteed payments up to a pre-determined limit.</p>
          </div>

        </div>
        <div class="col-md-4 ic-grp">
          <div class="text-center img-tag">

          </div>
          <div>
            <p class="tit-0 maj ">C.O.D. Automatic<sup>®</sup></p>
            <p class="tit-0 sml">Receive C.O.D. payments in approximately 2-3 days from the delivery
              date.</p>
          </div>
        </div>
        <div class="col-md-4 ic-grp ">
          <div class="text-center img-tag">

          </div>
          <div>
            <p class="tit-0 maj">C.O.D. Direct<sup>®</sup></p>
            <p class="tit-0 sml">Receive C.O.D. payments in approximately 6 days from the delivery date.
            </p>
          </div>
        </div>
      </div>


    </div>
    <div class="container input-form head2">
      <p class="featured-resources__inner-container cmd">C.O.D. Delayed Deposit Benefits</p>
      <hr class="featured-resources__hr sol">

    </div>



  </div>
  <div class="container pic-comb sma">
    <div>
      <img class="sub-image" alt="trade-credit-image" src="../../../../assets/redesignImages/taking_note.png">
    </div>
    <div class="trade-credit__inner-container">

      <h3>Eliminate Manual Check Deposits</h3>
      <p id="para-block">Reduce risks and bank fees associated with the manual handling of checks with
        automatic daily deposit of funds to the bank of your choice. Plus, get email notifications when
        there are new C.O.D. checks awaiting deposit.</p>
      <h3>Better Manage Cash Flow</h3>
      <p id="para-block">Secure web access to view check images, manage deposits and download remittance data
        to simplify record keeping.</p>
      <h3>Receive Timely Information</h3>

      <p id="para-block">Daily, electronic delivery of reports provides advance notice of scheduled deposits
        and returned items. If there is a returned payment, you have the option for automatic second
        presentation of dishonored checks.</p>


      <div class="hero-panel-button bus_btn">
        <a class="get-secret-btn" href="/contact-us" tabindex="-1">Contact Us<img class="arrow-head-left"
            src="../../../../assets/redesignImages/button-menu.png"></a>
      </div>
    </div>

  </div>
  <div class="container input-form">
    <p class="featured-resources__inner-container pcb">Everything You Need to Manage Your C.O.D. Payments</p>
    <hr class="featured-resources__hr">

  </div>
  <div class="row container-fluid cont-bg0 grid2" style="margin-bottom:70px">
    <div class="col-md-4 max-1200 ic-grp ">
      <div class="text-center ico-img">
        <img src="../../../../assets/redesignImages/description.png">
      </div>

      <div class="wrapper">

        <p class="tit-0 maj vmrg">C.O.D. Direct<sup>®</sup> Enrollment Form</p>
        <p class="tit-0 sml vmrg">Get your C.O.D. funds faster by having your checks directly deposited in
          approximately 6 business days after your UPS C.O.D. packages are delivered.</p>
        <div id="btn-block">
          <a class="COD_btn"
            href="../../../../../assets/COD_Direct_Enrollment_Form.pdf"
            target="_blank" tabindex="-1" rel="noopener">Enroll<img class="arrow-head-left"
              src="../../../../assets/redesignImages/blueButton.png"></a>
        </div>
      </div>

    </div>
    <div class="col-md-4 ic-grp">
      <div class="text-center ico-img png2">
        <img src="../../../../assets/redesignImages/upload_file.png">
      </div>
      <div class="wrapper">
        <p class="tit-0 maj vmrg">C.O.D. Automatic<sup>®</sup> and C.O.D. Secure<sup>®</sup> Login</p>
        <p class="tit-0 sml vmrg">View your UPS C.O.D. remittance statements and check copies. Quickly
          download them in multiple formats for simplified invoice reconciliation.</p>
        <div id="btn-block">
          <a class="COD_btn" tabindex="-1" target="_blank" href="https://cod.ups.com/shipper/app/login.html"
            rel="noopener">Login<img class="arrow-head-left" src="../../../../assets/redesignImages/blueButton.png"></a>
        </div>
      </div>
    </div>
    <div class="col-md-4 ic-grp ">
      <div class="text-center ico-img png2">
        <img src="../../../../assets/redesignImages/lock_clock.png">
      </div>
      <div class="wrapper">
        <p class="tit-0 maj vmrg">C.O.D. Delayed Deposit Website</p>
        <p class="tit-0 sml vmrg">Log in with your My UPS.com<sup id="sup-l">®</sup> ID to select the dates
          you want customers’ checks deposited.</p>
        <div id="btn-block">
          <a class="COD_btn" tabindex="-1"
            href="https://www.ups.com/lasso/login?returnto=https%3a//www.ups.com/ddo/summary%3floc%3den_US&reasonCode=-1&appid=DDO"
            target="_blank" rel="noopener">Login<img class="arrow-head-left"
              src="../../../../assets/redesignImages/blueButton.png"></a>
        </div>
      </div>
    </div>
  </div>



</div>